export default "| **S-16** | Mandate, First 100 Days and What's Next are apps in personal workspaces; Mandate moves to /apps/mandate | #1316 | Oct 29 |"